import { defineMessages } from 'react-intl';

const actionMessages = defineMessages({
    timeline: {
        id: 'timeline-action',
        defaultMessage: 'Timeline',
    },
    edit: {
        id: 'edit-action',
        defaultMessage: 'Edit',
    },
    mergeAction: {
        id: 'merge-action',
        defaultMessage: 'Merge',
    },
    dashboard: {
        id: 'dashboard-action',
        defaultMessage: 'Dashboard',
    },
    quickView: {
        id: 'quick-view-action',
        defaultMessage: 'Quick View',
    },
    delete: {
        id: 'delete-action',
        defaultMessage: 'Delete',
    },
    deactivate: {
        id: 'deactivate-action',
        defaultMessage: 'Deactivate',
    },
    addContent: {
        id: 'add-content-action',
        defaultMessage: 'Add',
    },
    addAsset: {
        id: 'add-asset-action',
        defaultMessage: 'Add Asset',
    },
    info: {
        id: 'info-action',
        defaultMessage: 'Information',
    },
    reorderContent: {
        id: 'reorder-content-action',
        defaultMessage: 'Reorder',
    },
    actions: {
        id: 'action-action',
        defaultMessage: 'Actions',
    },
    more: {
        id: 'more-action',
        defaultMessage: 'More',
    },
    connect: {
        id: 'connect-action',
        defaultMessage: 'Connect',
    },
    disconnect: {
        id: 'disconnect-action',
        defaultMessage: 'Disconnect',
    },
    splice: {
        id: 'splice-action',
        defaultMessage: 'Splice',
    },
    break: {
        id: 'break-action',
        defaultMessage: 'Break',
    },
    damage: {
        id: 'damage-action',
        defaultMessage: 'Damage',
    },
    fix: {
        id: 'fix-action',
        defaultMessage: 'Fix',
    },
    split: {
        id: 'split-action',
        defaultMessage: 'Split',
    },
    view: {
        id: 'view-action',
        defaultMessage: 'View',
    },
    insert: {
        id: 'insert-action',
        defaultMessage: 'Insert',
    },
    remove: {
        id: 'remove-action',
        defaultMessage: 'Remove',
    },
    take: {
        id: 'take-action',
        defaultMessage: 'Take',
    },
    release: {
        id: 'release-action',
        defaultMessage: 'Release',
    },
    objectNotOnTheMap: {
        id: 'object-not-on-the-map',
        defaultMessage: 'The object is not on the map',
    },
    issue: {
        id: 'issue-action',
        defaultMessage: 'Issue',
    },
    void: {
        id: 'void-action',
        defaultMessage: 'Void',
    },
    print: {
        id: 'print-action',
        defaultMessage: 'Print',
    },
    send: {
        id: 'send-action',
        defaultMessage: 'Send',
    },
    reserve: {
        id: 'reserve-action',
        defaultMessage: 'Reserve',
    },
    free: {
        id: 'free-action',
        defaultMessage: 'Free',
    },
    download: {
        id: 'download',
        defaultMessage: 'Download',
    },
    pause: {
        id: 'pause',
        defaultMessage: 'Pause',
    },
    escalate: {
        id: 'escalate',
        defaultMessage: 'Escalate',
    },
    reject: {
        id: 'reject',
        defaultMessage: 'Reject',
    },
    anotherOrgUnit: {
        id: 'another-org-unit',
        defaultMessage: 'Another Org Unit',
    },
    transform: {
        id: 'transform',
        defaultMessage: 'Transform',
    },
    merge: {
        id: 'merge',
        defaultMessage: 'Merge',
    },
    marking: {
        id: 'marking-communication',
        defaultMessage: 'Marking',
    },
    changeOwner: {
        id: 'change-ticket-owner',
        defaultMessage: 'Change owner',
    },
    linkService: {
        id: 'ticket-link-service',
        defaultMessage: 'Link service',
    },
});

export default actionMessages;
